import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <section className="mx-auto max-w-md text-center">
      <h2 className="text-4xl font-bold text-appsol-900">404</h2>
      <p className="mt-2 text-slate-600">{t('errors.notFound')}</p>
      <Link to="/" className="mt-4 inline-block text-appsol-500 underline">
        ←
      </Link>
    </section>
  );
}
